export default __webpack_public_path__ + "static/media/polo1.3e3a6a52.png";